type BaseFetch = {
  (
    url: string,
    options: {
      method: "POST" | "GET";
      headers: HeadersInit;
      body?: BodyInit;
    }
  ): Promise<unknown>;
};
export const baseFetch: BaseFetch = async (url, options) => {
  try {
    const fetchResponse = await fetch(url, {
      ...options,
      headers: {
        "x-app-version": "mmgp-frontend/undefined-x",
        "Content-Type": "application/json",
        ...options.headers,
      },
      body: options.body ? options.body : null,
    });
    if (fetchResponse) {
      return fetchResponse.json();
    } else {
      throw new Error("Invalid response");
    }
  } catch (exception) {
    console.error("baseFetch_error: ", exception);
    return {};
  }
};
